import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { ContentfulService } from 'app/core/services/contentful.service';
import { DomSanitizer } from '@angular/platform-browser';

const { contentful } = environment;

@Component({
  selector: 'app-cms-content',
  templateUrl: './cms-content.component.html',
  styleUrls: ['./cms-content.component.scss']
})
export class CmsContentComponent implements OnInit {
  @Input() key: string;
  @Input() placeholder: string = '';
  public isContentfulActive = contentful.active;
  public content: string;

  constructor(private contentfulService: ContentfulService, private sanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    if (contentful.active) {
      this.contentfulService.getPlatformContent(this.key).then((content) => {
        this.content = content;
      });
    }
  }
}
